
$(document).ready(function(){
  
  var preSelectedColor = new URLSearchParams(location.search).get('color');
  
  var preSelectedSize = new URLSearchParams(location.search).get('size');
  
  var p = $(".color-opt").find("[colorsel='"+preSelectedColor+"']");
  
  var p1 = $(".size-opt").find("[colorsel='"+preSelectedSize+"']");
  
  if(!p.hasClass("preselected"))
  {
    p.addClass("preselected selected");
    p.siblings().removeClass("preselected selected");
  }
  
  if(!p1.hasClass("preselected"))
  {
    p1.addClass("preselected selected");
    p1.siblings().removeClass("preselected selected");
  }
  
//   if(p != undefined && p1 != undefined)
//   {
//     var newurl = window.location.href;
//     newurl = newurl.split("?");
//   	window.history.replaceState('', '', newurl[0]);
//   }
  
  $(".custom-opt-links").find("option").each(function(){
  	var img = $(this).attr("data-img");
    var colr = $(this).attr("data-color");
    var siz = $(".size-opt .preselected").attr("colorsel");
    if($(this).attr('data-size') == siz)
    {
    	$("[colorsel='"+colr+"']").find("img").attr("src",img);
    }
  });

  $(".color-opt .image-and-color-name a").on("click",function(e){
  	e.preventDefault();
	var val = $(this).parents(".image-and-color-name").attr("colorsel");
    var opt = $(".size-opt").find(".preselected").attr("colorsel");
    console.log(opt);
    if(opt != undefined)
    {
      var url = $("[data-opt='"+val+"/"+opt+"']").attr("data-link");
      var string = "?color="+val+"&size="+opt;
      if(url != undefined)
      {
          window.location.href = url+string;
      }
    }
    else
    {
      var url = $("[data-opt='"+val+"']").attr("data-link");
      var string = "?color="+val;
      if(url != undefined)
      {
          window.location.href = url+string;
      }
    }
  });
  
  $(".size-opt .image-and-color-name a").on("click",function(e){
  	e.preventDefault();
	var val = $(this).parents(".image-and-color-name").attr("colorsel");
    var opt = $(".color-opt").find(".preselected").attr("colorsel");
    var url = $("[data-opt='"+opt+"/"+val+"']").attr("data-link");
    var string = "?color="+opt+"&size="+val;
    if(url != undefined)
    {
     window.location.href = url+string;
    }
  });
  
  var preselected = $(".color-opt .image-and-color-name.preselected").find(".color-name").html();
  $(".color-opt span.clrselected").html(preselected);
  
  $(".custom-option .color-opt .image-and-color-name").hover(function(){
      var clrname = $(this).find("a").find(".color-name").html();
      $(".color-opt span.clrselected").html(clrname);
      $(this).addClass("selected");
      $(this).siblings(".image-and-color-name").removeClass("selected");

    }, function(){
      var defaultclr = $(".color-opt  .image-and-color-name.link--border.preselected label.color-name").html();
      $(".color-opt span.clrselected").html(defaultclr);
      $(".color-opt .image-and-color-name.preselected").addClass("selected");
      $(".color-opt .image-and-color-name.preselected").siblings(".image-and-color-name").removeClass("selected");
  });

  $(document).on("click",".exta-item",function(){
    $(this).toggleClass("active");
    $(this).siblings(".exta-item").removeClass("active");
  });

  $("#atc_button").on("click",function(){
    var optSelected = $(".exta-item.active").length;
    if(optSelected != 0)
    {
      var id = [];
      $(".exta-item.active").each(function(){
        id.push($(this).attr("data-id"));
      });
      if(id != '')
      {
        for (let i = 0; i < id.length; i++) {
          $.ajax({
            type: 'POST', 
            url: '/cart/add.js', 
            data: "quantity=1&id="+id[i],
            async:false,
            success: function(data){
             console.log("done"); 
              
            }
          });
        }
      }
      
    }
  });

  var $cartBtnWrapper = $('.template-product .product-block .payment-buttons');
  // if($('section.Product').hasClass("enable-sticky")){
    $.fn.isInViewport = function() {
      didScroll = true;
      var elementTop = $(this).offset().top;
      var elementBottom = elementTop + ($(this).outerHeight() - $(this).innerHeight() - 0);
      var viewportTop = $(window).scrollTop() - 50 ;
      var viewportBottom = viewportTop + $(window).height() + 80;
      return elementBottom > viewportTop && elementTop < viewportBottom;
    };


    function controlStickyCartBtn() {
      if (!$cartBtnWrapper.isInViewport() && !$cartBtnWrapper.find(':submit.add-to-cart').is(":disabled")) {
        $cartBtnWrapper.addClass('cartBtnStickyHeightFixActive');
      } else {
        $cartBtnWrapper.removeClass('cartBtnStickyHeightFixActive');
      }
    }

    //controlStickyCartBtn();
  if($cartBtnWrapper.length == 1)
  {
    $(window).on('resize scroll', function() {
      controlStickyCartBtn();
    });
  }
  // }

});

 $('.exta-items').slick({
    infinite: false,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    nextArrow:'<div class="arrow-next"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--! Font Awesome Pro 6.2.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path d="M0 256C0 397.4 114.6 512 256 512s256-114.6 256-256S397.4 0 256 0S0 114.6 0 256zM241 377c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l87-87-87-87c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L345 239c9.4 9.4 9.4 24.6 0 33.9L241 377z"/></svg></div>',
    prevArrow:'<div class="arrow-prev"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--! Font Awesome Pro 6.2.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path d="M512 256C512 114.6 397.4 0 256 0S0 114.6 0 256S114.6 512 256 512s256-114.6 256-256zM271 135c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-87 87 87 87c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L167 273c-9.4-9.4-9.4-24.6 0-33.9L271 135z"/></svg></div>',
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]
  });

  
//   $(".variant-input").each(function(){
//   //console.log("run");
//   if($(this).find("input").attr("checked")){   
//   $(this).addClass("selected");
//     $(this).find("a").find(".variant__button-label").addClass("selected");
//   }else{
//       //$(this).addClass("this not");
//   }
// });








////
/* ---  OLD CODE -----
  var arr = [];
  var handle ='';
   //console.log(handle);
  $("ul.color--names li").each(function(){
    //const removed = str.split('_')[0];
    //console.log(str);

  //const find = strr.split('_')[0];
    var find = $(this).text();
     console.log(find);
    $("ul.color--images li").each(function(){
      
    var img = $(this).find("img").attr("src");
      //var not = "invalidaddress";
      var result = img.includes("color_"+find);
      img = img.substring(img.indexOf(">") + 1);
     if ( result == true)
     {
       // console.log(result);
       //console.log(img);
       $("ul.product--links li").each(function(){
    var links = $(this).text();
      var result = links.includes("color_"+find);
         var result2 = '';
        //links = />(.+)/.exec(links)[1];
         links = links.substring(links.indexOf(">") + 1);
      if ( result == true )
     {
        //console.log(result);
       //console.log(links);
       // console.log(result2)
       arr.push("<div class='image-and-color-name "+"link--border"+result2+"' colorsel='"+find+"'><a class="+"link"+result2+" href="+ links +"><img src="+img+"><label class='color-name'>"+ find +"</label></a></div>")
     }
    }) 
     }
      
    })
   
  })
  // console.log(arr);
  $(".append--here").html(arr);

// $(".append--here .image-and-color-name").hover(function(){
//     var clrname = $(this).find("a").find(".color-name").html();
//     //console.log(clrname);
//    $(".final--colors.variant-wrapper.js.custom-variants span.clrselected").html(clrname);
  
// }); 
  $(".append--here .image-and-color-name").hover(function(){
    var clrname = $(this).find("a").find(".color-name").html();
    console.log(clrname);
   $(".final--colors.variant-wrapper.js.custom-variants span.clrselected").html(clrname);
    
  }, function(){
    var defaultclr = $(".image-and-color-name.link--border.preselected label.color-name").html();
    console.log(defaultclr)
   $(".final--colors.variant-wrapper.js.custom-variants span.clrselected").html(defaultclr);
});

  var pageURL = $(location).attr("href");
            console.log(pageURL);

$(".image-and-color-name").each(function(){
  console.log("run");
  var color = $(this).attr("colorsel");
  var url = $(location).attr("href");
  var final = url.includes(color)
  console.log(final);
  if( final == true ){   
  $(this).addClass("selected preselected");
   var getselected = $(".image-and-color-name.link--border.selected label.color-name").text();
    //$(".clrselected").text(getselected);
  }else{
      //$(this).addClass("this not");
  }
});
  var defaultclr = $(".image-and-color-name.link--bordertrue.selected a.linktrue label.color-name").html();
   $(".final--colors.variant-wrapper.js.custom-variants span.clrselected").html(defaultclr);
  $(".image-and-color-name.link--border").hover(function(){
    $(this).addClass("selected");
    $(this).siblings(".image-and-color-name").removeClass("selected");
  },function(){
  	$(".image-and-color-name.preselected").addClass("selected");
    $(".image-and-color-name.preselected").siblings(".image-and-color-name").removeClass("selected");
  }); 
 
//   $(".image-and-color-name.link--border").on("click", function(){
//     var get = $(this).find("label.color-name").text();
//   localStorage.setItem("color", get);
//   })
//   var local = localStorage.getItem("color");
//   console.log(local)
//   if ( local != "" || local != undefined )
//   {
//     console.log("inlocal")
//   $(".image-and-color-name.link--border[colorsel='"+local+"']").addClass("selected");
//     $(".image-and-color-name.link--border[colorsel='"+local+"']").prevAll(".image-and-color-name.link--border").removeClass("selected");
//     $(".image-and-color-name.link--border[colorsel='"+local+"']").nextAll(".image-and-color-name.link--border").removeClass("selected");
//   }
//   else
//   {
//     console.log("outlocal")
//    $(".image-and-color-name.link--border:first-child").addClass("selected");
  
//   }
  var getselected = $(".image-and-color-name.link--border.selected label.color-name").text();
    $(".clrselected").text(getselected);


-----  */
  
  
  